// extracted by mini-css-extract-plugin
module.exports = {"label":"label__2KHmK","green":"green__1p6d0","blue":"blue__pib-9","orange":"orange__3fH_y","labels":"labels__sM3lu"};